import { GridHeaderCellProps } from '@progress/kendo-react-grid';

export const CenterHeaderCell = (props: GridHeaderCellProps) => {
  const { title } = props;
  return <div className="flex justify-center items-center m-auto">{title}</div>;
};
